import { languages } from '../../i18n/i18n.language-config';
import { usePlatformLanguage } from './usePlatformLanguage';

const usePlatformRegion = () => {
  const region = usePlatformLanguage();

  return {
    isUS: region === languages['en-US'],
    isUK: region === languages['en-GB'],
    isAU: region === languages['en-AU'],
  };
};

export default usePlatformRegion;
